<template>
	<form class="form-horizontal" @submit.prevent="save">
		<div class="animated fadeIn">
			<b-card>
				<div class="display-table full-width mb-2">
					<strong class="card-title">{{$route.meta.label}}</strong>
				</div>
				<b-row>
					<ResponseAlert ref="response" />
					<b-col sm="6" class="mx-auto mb-2">
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Kode')}" label="Kode">
							<b-form-input v-model="models.kodeLimbah" v-validate="'required'" data-vv-name="Kode">
							</b-form-input>
							<div v-if="errors.has('Kode')">
								<p class="text-danger">{{ errors.first('Kode') }}</p>
							</div>
						</b-form-group>
						<b-form-group v-bind:class="{ 'is-invalid': errors.has('Nama')}" label="Nama">
							<b-form-input v-model="models.namaLimbah" v-validate="'required'" data-vv-name="Nama">
							</b-form-input>
							<div v-if="errors.has('Nama')">
								<p class="text-danger">{{ errors.first('Nama') }}</p>
							</div>
						</b-form-group>
						<b-form-group>
							<div class="col-sm-12 no-padding">
								<label class="radio-inline mr-2">
									<input type="checkbox" v-model="models.rumahTangga"> Rumah Tangga
								</label>
								<label class="radio-inline mr-2">
									<input type="checkbox" v-model="models.umk"> UMK
								</label>
								<label class="radio-inline mr-2">
									<input type="checkbox" v-model="models.fasyankes"> Fasyankes
								</label>
								<label class="radio-inline no-padding">
									<input type="checkbox" v-model="models.pelakuUsaha"> Pelaku Usaha
								</label>
							</div>
						</b-form-group>
					</b-col>
				</b-row>
				<template #footer>
					<b-button type="submit" variant="primary" class="btn-min-width float-right">
						Simpan
					</b-button>
					<b-button type="button" variant="light" class="btn-min-width float-right" @click="$router.go(-1)">
						Kembali
					</b-button>
				</template>
			</b-card>
		</div>
	</form>
</template>
<script>
	import ResponseAlert from '@/components/response_alert';

	export default {
		name: 'FormLimbahB3',
		components: {
			ResponseAlert,
		},
		data() {
			return {
				config: {
					uri: this.$route.meta.permission.link,
				},
				models: {
					kodeLimbah: "",
					namaLimbah: "",
					rumahTangga: false,
					umk: false,
					fasyankes: false,
					pelakuUsaha: false,
					createdBy: "",
				},
				masters: {
				
				},
			}
		},
		created() {
			const _ = this
			_.getById();
		},
		methods: {
			async getById() {
				const _ = this;
				try {
					if (_.$route.params.id) {
						const request = await _.$axios.get(`LimbahB3/${_.$route.params.id}`);
						const data = request.data.data;
						_.models.kodeLimbah = data.kodeLimbah;
						_.models.namaLimbah = data.namaLimbah;
						_.models.rumahTangga = data.rumahTangga;
						_.models.umk = data.umk;
						_.models.fasyankes = data.fasyankes;
						_.models.pelakuUsaha = data.pelakuUsaha;
						_.models.createdBy = data.createdBy;
					}
				} catch (error) {
					_.$router.push({ name: 'page404' });
				}
				
			},
			save() {
				const _ = this;
				const user = JSON.parse(localStorage.getItem('user'));
				_.$validator.validate().then(valid => {
					if (valid) {
						let request = "";
						if (!_.$route.params.id) {
							_.models.createdBy = user.name;
							request = _.$axios.post(`LimbahB3`, _.models);
						} else {
							_.models.id = _.$route.params.id;
							_.models.modifiedBy = user.name;
							request = _.$axios.put(`LimbahB3/${_.$route.params.id}`, _.models);
						}
						request
						.then(() => _.$router.push({
							name: _.config.uri
						}))
						.catch(error => _.$refs.response.setResponse(error.response.data.message, 'danger'));
						
					} else {
						window.scrollTo(0, 0);
					}
				});
			}
		}
	}
</script>